<script>
export default {
    name: "ConstructionInstallmentsTab",
    props: {
        construction: {required: true}
    }
}
</script>

<template>
    <div>
        <table class="table table-borderless table-striped">
            <tbody>
            <tr>
                <td>
                    <strong>Parcelas entrada</strong>
                    <p v-if="construction.advance_installments">{{ construction.advance_installments || 0 }}</p>
                    <p v-if="!construction.advance_installments">-</p>
                </td>
                <td>
                    <strong>Valor entrada</strong>
                    <p v-if="construction.advance_payment">{{ construction.advance_payment | money }}</p>
                    <p v-if="!construction.advance_payment">-</p>
                </td>
            </tr>
            <tr>
                <td>
                    <strong>Parcelas mensais</strong>
                    <p v-if="construction.monthly_installments">{{ construction.monthly_installments }}</p>
                    <p v-if="!construction.monthly_installments">-</p>
                </td>
                <td>
                    <strong>Valor mensal</strong>
                    <p v-if="construction.monthly_installments_value">{{ construction.monthly_installments_value | money }}</p>
                    <p v-if="!construction.monthly_installments_value">-</p>
                </td>
            </tr>
            <tr>
                <td>
                    <strong>Parcelas trimestrais</strong>
                    <p v-if="construction.quarterly_installments">{{ construction.quarterly_installments }}</p>
                    <p v-if="!construction.quarterly_installments">-</p>
                </td>
                <td>
                    <strong>Valor trimestral</strong>
                    <p v-if="construction.quarterly_installments_value">{{ construction.quarterly_installments_value | money }}</p>
                    <p v-if="!construction.quarterly_installments_value">-</p>
                </td>
            </tr>
            <tr>
                <td>
                    <strong>Parcelas semestrais</strong>
                    <p v-if="construction.semiannual_installments">{{ construction.semiannual_installments }}</p>
                    <p v-if="!construction.semiannual_installments">-</p>
                </td>
                <td>
                    <strong>Valor semestral</strong>
                    <p v-if="construction.semiannual_installments_value">{{ construction.semiannual_installments_value | money }}</p>
                    <p v-if="!construction.semiannual_installments_value">-</p>
                </td>
            </tr>
            <tr>
                <td>
                    <strong>Parcelas anuais</strong>
                    <p v-if="construction.annual_installments">{{ construction.annual_installments }}</p>
                    <p v-if="!construction.annual_installments">-</p>
                </td>
                <td>
                    <strong>Valor anual</strong>
                    <p v-if="construction.annual_installments_value">{{ construction.annual_installments_value | money }}</p>
                    <p v-if="!construction.annual_installments_value">-</p>
                </td>
            </tr>
            <tr>
                <td>
                    <strong>Parcelas chaves</strong>
                    <p v-if="construction.keys_installments">{{ construction.keys_installments }}</p>
                    <p v-if="!construction.keys_installments">-</p>
                </td>
                <td>
                    <strong>Valor chaves</strong>
                    <p v-if="construction.keys_installments_value">{{ construction.keys_installments_value | money }}</p>
                    <p v-if="!construction.keys_installments_value">-</p>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionInstallmentsTab.vue?4cc2d7b2